// extracted by mini-css-extract-plugin
module.exports = {"root":"Spacer_root__2MD3C"};